<template>
  <sf-modal v-if="showModal" size="xs" @close="closeModal">
    <template #title>{{ titleLabel }}</template>

    <template #body>
      <div
        v-for="periodScope in periodScopes"
        :key="periodScope"
        class="sf-level sf-level-between sf-below-1"
      >
        <label class="sf-form-check sf-form-check-rounded sf-inline-block">
          <input
            v-model="selectedPeriodScope"
            type="radio"
            :value="periodScope"
          />
          <span class="sf-form-check-content sf-level">
            <span class="sf-form-check-indicator" />
            <span>{{ periodScopeLabels[periodScope] }}</span>
          </span>
        </label>
      </div>
    </template>

    <template #footer>
      <a
        class="sf-btn sf-btn-danger"
        :class="{ 'sf-disabled': !selectedPeriodScope }"
        @click="confirm"
      >
        {{ confirmButtonLabel }}
      </a>
      <a class="sf-btn" @click="closeModal">{{ cancelButtonLabel }}</a>
    </template>
  </sf-modal>
</template>

<script lang="ts" setup>
import { SfModal } from '@app/shared/vue/components/sf-modal'
import { ref } from 'vue'
import { removeTodoPeriodScopes } from '@app/application/communication/constants'

const periodScopes = [
  removeTodoPeriodScopes.CURRENT,
  removeTodoPeriodScopes.CURRENT_AND_FOLLOWING,
  removeTodoPeriodScopes.FOLLOWING,
]

const periodScopeLabels = {
  [removeTodoPeriodScopes.CURRENT]: window.I18n.t(
    'communication.recurring_todo_removal_modal.current_period'
  ),
  [removeTodoPeriodScopes.CURRENT_AND_FOLLOWING]: window.I18n.t(
    'communication.recurring_todo_removal_modal.current_and_following_periods'
  ),
  [removeTodoPeriodScopes.FOLLOWING]: window.I18n.t(
    'communication.recurring_todo_removal_modal.following_periods'
  ),
}

const titleLabel = window.I18n.t(
  'communication.recurring_todo_removal_modal.title'
)
const cancelButtonLabel = window.I18n.t('common.cancel')
const confirmButtonLabel = window.I18n.t('common.remove')

const showModal = ref(true)
const selectedPeriodScope = ref<string | null>(null)
let onConfirm: (periodScope: string) => void

const openModal = ({
  onConfirm: confirmCallback,
}: {
  onConfirm: (periodScope: string) => void
}) => {
  showModal.value = true
  onConfirm = confirmCallback
}

const closeModal = () => {
  showModal.value = false
}

const confirm = () => {
  onConfirm(selectedPeriodScope.value as string)
  closeModal()
}

defineExpose({
  openModal,
})
</script>
